<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M29.1094 15.7962C29.1094 16.5385 28.5073 17.1401 27.7646 17.1401L3.84008 17.1401C3.09735 17.1401 2.49526 16.5385 2.49526 15.7962C2.49526 15.054 3.09735 14.4523 3.84008 14.4523L27.7646 14.4523C28.5073 14.4523 29.1094 15.054 29.1094 15.7962Z"
      :fill="color"
    />
    <path
      d="M15.3826 4.20613C15.9078 4.73096 15.9078 5.58187 15.3826 6.1067L4.73847 16.7436C4.21328 17.2685 3.36179 17.2685 2.8366 16.7436C2.31141 16.2188 2.31141 15.3679 2.8366 14.8431L13.4807 4.20613C14.0059 3.68129 14.8574 3.68129 15.3826 4.20613Z"
      :fill="color"
    />
    <path
      d="M15.4017 27.4189C14.8765 27.9437 14.025 27.9437 13.4999 27.4189L2.85571 16.7819C2.33053 16.2571 2.33053 15.4062 2.85571 14.8814C3.3809 14.3565 4.2324 14.3565 4.75758 14.8814L15.4017 25.5183C15.9269 26.0431 15.9269 26.894 15.4017 27.4189Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: "IconArrowWaitingSidebar",
  props: {
    color: {
      type: String,
      default: "#F18E35",
    },
  },
};
</script>

<style scoped></style>
